import styles from "./Sidebar.module.scss";
import logo from "../../../../assets/images/layouts/180x70.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import { Link } from "react-router-dom";
import logoutIcon from "../../../../assets/images/layouts/SignOut.svg";
import copy from "../../../../assets/images/copy-icon/Copy.svg";
import copied from "../../../../assets/images/copy-icon/Copied.svg";
import { useState } from "react";
import closeIcon from "../../../../assets/images/layouts/navigation-icons/X (1).svg";
import { useSite } from "../../../../context/TranslationContext";
import map from "../../../../assets/images/layouts/navigation-icons/MapPinLine.svg";
// import pack from "../assets/images/layouts/navigation-icons/Package.svg";
import box from "../../../../assets/images/layouts/navigation-icons/Box.svg";
import card from "../../../../assets/images/layouts/navigation-icons/Cardholder.svg";
import creditCard from "../../../../assets/images/layouts/navigation-icons/Cardholder.svg";
import filePlus from "../../../../assets/images/layouts/navigation-icons/FilePlus.svg";
import shoppingCart from "../../../../assets/images/layouts/navigation-icons/ShoppingCart.svg";
import truck from "../../../../assets/images/layouts/navigation-icons/Truck.svg";
import Wolt from "../../../../assets/images/layouts/navigation-icons/wolt.svg";
import mailbox from "../../../../assets/images/layouts/navigation-icons/Mailbox.svg";
import check from "../../../../assets/images/layouts/navigation-icons/CheckCircle.svg";
import promocode from "../../../../assets/images/layouts/navigation-icons/CodeBlock.svg";
import attorney from "../../../../assets/images/layouts/navigation-icons/attorney-fee-svgrepo-com.svg";
import MainButton from "../../../shared/button/MainButton";
import { ReferalServices } from "../../../../services/referal.service";
import { setCookie } from "../../../../utils/utils";
import Spinner from "../../../shared/spinner/Spinner";
import { fetchUser } from "../../../../redux/Slices/userProfile";
import {
  setMainAccount,
  setRefresh,
} from "../../../../redux/Slices/referalMainAcc";

interface props {
  setShowModal: (value: boolean) => void;
  setLogoutConfrim: (value: boolean) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (value: boolean) => void;
}

const Sidebar = ({
  setShowModal,
  setLogoutConfrim,
  sidebarOpen,
  setSidebarOpen,
}: props) => {
  const [copiedText, setCopiedText] = useState<Boolean>(false);
  const { userInfo } = useSelector((state: RootState) => state.userProfile);
  const pathName = window.location.pathname;
  const formattedPath = pathName.replace("/account", "").replace(/^\/+/, "");
  const [mainAccLoading, setmainAccLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const mainAccount = useSelector(
    (state: RootState) => state.referal.mainAccount,
  );

  const handleCopy = () => {
    if (userInfo?.id) {
      navigator.clipboard
        .writeText(userInfo.id.toString())
        .then(() => {
          setCopiedText(true);
          setTimeout(() => {
            setCopiedText(false);
          }, 1000);
        })
        .catch((err) => console.error("Failed to copy text:", err));
    }
  };
  const returnToMainAccount = () => {
    dispatch(setMainAccount(false));
    setmainAccLoading(true);
    ReferalServices.returnToMainAccount()
      .then((res) => {
        const token = res.data.original.token;
        setCookie("ColibriToken", token, 14);
        dispatch(fetchUser());
        dispatch(setRefresh(true));
        window.location.reload();
      })
      .catch(() => console.error("err"))
      .then(() => setmainAccLoading(false));
  };
  const { data } = useSelector((state: RootState) => state.translationData);
  const user_navigations = [
    {
      name: data?.auth_left_sidebar_foreign_addresses,
      title: data?.auth_left_sidebar_foreign_addresses,
      path: "my-foriegn-locations",
      logo: map,
      search: false,
      info: false,
    },

    {
      name: data?.auth_left_sidebar_parcels,
      title: data?.auth_left_sidebar_parcels,
      path: "my-packages",
      logo: box,
      search: true,
      info: true,
    },
    {
      name: data?.special_order || "Sifariş et",
      title: data?.special_order || "Sifariş et",
      path: "special-order",
      logo: shoppingCart,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_balance,
      title: data?.auth_left_sidebar_balance,
      path: "my-balance",
      logo: card,
      search: false,
      info: false,
    },
    {
      name: data?.service_debts_title || "Xidmət borcları",
      title: data?.service_debts_title || "Xidmət borcları",
      path: "service-debts",
      logo: card,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_bank_cards || "Bank Kartlarım",
      title: data?.auth_left_sidebar_bank_cards || "Bank Kartlarım",
      path: "bank-cards",
      logo: creditCard,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_yp_order,
      title: data?.auth_left_sidebar_yp_order,
      path: "ypOrder",
      logo: mailbox,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_courier_order,
      title: data?.auth_left_sidebar_courier_order,
      path: "courier",
      logo: truck,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_wolt,
      title: data?.auth_left_sidebar_wolt,
      path: "wolt",
      logo: Wolt,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_azerpost_order,
      title: data?.auth_left_sidebar_azerpost_order,
      path: "mail",
      logo: mailbox,
      search: false,
      info: false,
    },

    {
      name: data?.auth_left_sidebar_referral_accounts,
      title: data?.auth_left_sidebar_referral_accounts,
      // path: "referal-accounts",
      path: "lorem",
      logo: filePlus,
      search: false,
      info: false,
    },

    {
      name: data?.auth_left_sidebar_amazon_otp,
      title: data?.auth_left_sidebar_amazon_otp,
      path: "otp-code",
      logo: check,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_trendyol_otp,
      title: data?.auth_left_sidebar_trendyol_otp,
      path: "trendyol-otp",
      logo: check,
    },

    {
      name: data?.auth_left_sidebar_promo_code,
      title: data?.auth_left_sidebar_promo_code,
      path: "promocode",
      logo: promocode,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_attorney,
      title: data?.auth_left_sidebar_attorney,
      path: "attorney",
      logo: attorney,
      search: false,
      info: false,
    },
    {
      name: data?.auth_common_notifications,
      title: data?.auth_common_notifications,
      path: "notifications",
    },
  ];

  if (mainAccLoading) {
    return (
      <div className={styles.loading}>
        <Spinner size="large" />
      </div>
    );
  }

  return (
    <div id={styles.sidebar} className={` ${sidebarOpen ? styles.open : ""}`}>
      <div className={styles.sidebar}>
        <div className={styles.sidebar_content}>
          <div
            className={styles.close_icon}
            onClick={() => setSidebarOpen(false)}
          >
            <img src={closeIcon} alt="" />
          </div>
          <div className={styles.logo}>
            <Link to={`/`}>
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className={styles.user_id_section}>
            <p className={styles.id_title}>{data?.userSuit}</p>
            <p className={styles.id_title}>-</p>
            <p className={styles.user_id}>C{userInfo?.id}</p>
            <div className={styles.copy} onClick={handleCopy}>
              <img src={copiedText ? copied : copy} alt="copy" />
            </div>
          </div>

          <div className={styles.admin_nav_wrapper}>
            <ul className={styles.admin_panel_navigations}>
              {user_navigations.map((un, idx) => {
                if (un.path === "notifications") return null;

                if (un.path === "lorem") {
                  return (
                    <li
                      key={idx}
                      className={`${styles.admin_nav_list_comp} ${
                        window.location.href.includes("referal")
                          ? styles.active_nav
                          : ""
                      }`}
                      onClick={() => {
                        setShowModal(true);
                        setSidebarOpen(false);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className={styles.icon_box}>
                        <img src={un.logo} alt="logo" />
                      </div>
                      <p>{un.name}</p>
                    </li>
                  );
                }

                return (
                  <Link
                    to={`${un.path}`}
                    key={idx}
                    className={`${styles.admin_nav_list_comp} ${
                      un.path === formattedPath || formattedPath.startsWith(un.path + "/") ? styles.active_nav : ""
                    }`}
                    onClick={() => setSidebarOpen(false)}
                  >
                    <div className={styles.icon_box}>
                      <img src={un.logo} alt="logo" />
                    </div>
                    <p className={un.path === "special-order" ? styles.blink_red : undefined}>{un.name}</p>
                  </Link>
                );
              })}

              <div
                onClick={() => {
                  setLogoutConfrim(true);
                  setSidebarOpen(false);
                }}
                style={{ cursor: "pointer" }}
              >
                <li className={styles.admin_nav_list_comp}>
                  <img src={logoutIcon} alt="logo" />
                  <p>{data?.auth_logout_title}</p>
                </li>
              </div>
              {mainAccount && (
                <div
                  onClick={returnToMainAccount}
                  style={{ cursor: "pointer" }}
                >
                  <li className={styles.admin_nav_list_comp}>
                    <img src={logoutIcon} alt="logo" />
                    <p>{data?.switch_to_main_account}</p>
                  </li>
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
